"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetCategories = exports.assetOwners = void 0;
exports.assetOwners = [
    { id: 1, Name: 'Colin Wirt' },
    { id: 2, Name: 'Monash University - Reuse Centre' },
    { id: 3, Name: 'Monash University - BPD' },
    { id: 4, Name: 'Bikeshare Pty Ltd' },
];
exports.assetCategories = [
    { ID: 10, Code: 'SQR1', Caption: 'SoBi Quick Release 1' },
    { ID: 20, Code: 'FTP1', Caption: 'Tyre Pump' },
];
